import Ingredients from "./Ingredients";

export default Ingredients;
